import React from 'react';
import { Link } from 'react-router-dom';

const NewsUpdates = () => {
  const newsItems = [];

  return (
    <section className="section-spacing bg-gradient-to-br from-slate-50 to-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Background decoration */}
        <div className="absolute top-20 right-10 w-72 h-72 bg-gradient-to-br from-blue-500/5 to-indigo-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-64 h-64 bg-gradient-to-tr from-indigo-500/5 to-purple-500/5 rounded-full blur-2xl"></div>
        
        <div className="relative">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              News & Updates
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-indigo-700 mx-auto mb-6 rounded-full"></div>
            <p className="max-w-3xl mx-auto text-xl text-gray-600 leading-relaxed">
              Stay informed about Baniuaga Group's latest developments, achievements, and strategic initiatives driving growth across Timor-Leste.
            </p>
          </div>

          {newsItems.length > 0 ? (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {newsItems.map((item) => (
                <article key={item.id} className="card-hover bg-white rounded-xl border border-gray-200 overflow-hidden group relative shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-800 group-hover:bg-blue-100 group-hover:text-blue-800 transition-colors duration-300">
                          {item.category}
                        </span>
                        {item.isRecent && (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                            New
                          </span>
                        )}
                      </div>
                      <time className="text-sm text-gray-500 font-medium mt-0.5">
                        {item.date}
                      </time>
                    </div>
                    
                    <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition-colors duration-300 line-clamp-2 leading-tight">
                      {item.title}
                    </h3>
                    
                    <p className="text-gray-600 text-sm leading-relaxed mb-6">
                      {item.excerpt}
                    </p>
                    
                    <Link 
                      to={`/news/${item.id}`}
                      className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors duration-300 cursor-pointer group/link"
                    >
                      <span className="text-sm font-semibold">Read More</span>
                      <svg className="ml-2 w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          ) : null}

          <div className="text-center mt-12">
            <Link 
              to="/news" 
              className="inline-flex items-center bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 ease-out transform hover:scale-105"
            >
              View All News
              <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsUpdates;